import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import dayjs from "dayjs";
import queryKey from "../../../enumerations/queryKey";
import {
  apiApplyPromotion,
  apiGetExtraBonusRecord,
  apiGetPromoActiveUser,
  apiPromoActiveSetting,
  apiReceiveExtraBonus,
} from "../service";

export const useGetPromoActiveUser = (options) => {
  return useQuery(
    [queryKey.PROMO_ACTIVE_USER],
    () =>
      apiGetPromoActiveUser().then((res) => {
        const _data = res.data.data;
        // if (_data?.length <= 0) {
        //   return {
        //     requirement: null,
        //     current_count: null,
        //     last_update_at: null,
        //   };
        // }
        const requirement = _data.levels
          .map((level, index) => ({
            bonus: level.bonus,
            req_user: level.req_user,
            level: index + 1,
          }))
          .filter((level) => Number(level.bonus) !== 0);
        const current_count = [
          {
            active_user_count: _data?.active_user_count,
            not_receive_user_count: _data?.not_receive_user_count,
            total_reward_available: _data?.total_bonus_amount,
            is_blacklist: _data?.is_blacklist,
          },
        ];
        return {
          requirement: requirement,
          current_count: current_count,
          last_update_at: dayjs(_data.update_time).format("YYYY-MM-DD HH:mm"),
        };
      }),
    {
      ...options,
    },
  );
};

export const useApplyActivePromotion = () => {
  const cache = useQueryClient();
  return useMutation(({ params }) => apiApplyPromotion(params).then((res) => res.data.data), {
    onSuccess: () => {
      cache.invalidateQueries([queryKey.AGENT_BALANCE]);
      cache.invalidateQueries([queryKey.PROMO_ACTIVE_USER]);
    },
  });
};

export const useGetPromoExtraBonus = (options) => {
  return useQuery(
    [queryKey.PROMO_EXTRA_BONUS],
    () =>
      apiGetExtraBonusRecord().then((res) => {
        return res.data.data;
      }),
    {
      ...options,
    },
  );
};

export const useReceiveExtraBonus = () => {
  const cache = useQueryClient();
  return useMutation(({ level }) => apiReceiveExtraBonus(level).then((res) => res.data.data), {
    onSuccess: () => {
      cache.invalidateQueries([queryKey.AGENT_BALANCE]);
      cache.invalidateQueries([queryKey.PROMO_EXTRA_BONUS]);
    },
  });
};

export const useGetAgentPromoActiveSetting = (options) => {
  return useQuery(
    [queryKey.AGENT_PROMO_ACTIVE_SETTING],
    () =>
      apiPromoActiveSetting().then((res) => {
        return res.data.data.data;
      }),
    {
      ...options,
    },
  );
};
